import { AccountService } from "@/services";
class GLInfoService extends AccountService {
  fetchTeacherAvatarUrl(teacherId: string): Promise<any> {
    const expirationminutes = 120;
    return this.get(`users/${teacherId}/getuseravatarsasuri/${expirationminutes}`);
  }
}

export const InfoService = new GLInfoService();
